module.exports = __webpack_public_path__ + "img/BT-05.28c8f53d.png";